var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNavCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.825,
    height: 32,
    viewBox: "0 0 24.825 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4257",
    "data-name": "Group 4257",
    transform: "translate(-1353.589 -170.111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M-179.509,318.139a11.677,11.677,0,0,0-11.677,11.676,11.676,11.676,0,0,0,11.677,11.676,11.676,11.676,0,0,0,11.677-11.676A11.677,11.677,0,0,0-179.509,318.139Zm-.136,18.745a7.068,7.068,0,0,1-7.068-7.068,7.068,7.068,0,0,1,7.068-7.068,7.068,7.068,0,0,1,7.069,7.068A7.069,7.069,0,0,1-179.644,336.884Z",
    transform: "translate(1545.511 -148.028)",
    fill: "#43bece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M-181.625,427.577a19.718,19.718,0,0,1-11.716-3.846,2.393,2.393,0,0,1-.505-3.347,2.393,2.393,0,0,1,3.346-.505,14.969,14.969,0,0,0,17.273.335,2.393,2.393,0,0,1,3.324.635,2.393,2.393,0,0,1-.634,3.325A19.715,19.715,0,0,1-181.625,427.577Z",
    transform: "translate(1547.902 -225.466)",
    fill: "#fe3c02"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNavCollapse);
export default __webpack_public_path__ + "static/media/logo-nav-collapse.b2c51bbc3c54d8e2d5850fa55591b303.svg";
export { ForwardRef as ReactComponent };